import React, { useEffect, useState } from 'react';
import { Button, Checkbox, Collapse, CollapseProps, Modal, Table } from 'antd';
import { NameOf } from 'src/utils';
import { ColumnProps } from 'antd/lib/table';
import TableColumnBuilder from 'src/utils/core/TableColumnBuilder';
import { FilterValue } from 'antd/lib/table/interface';
import LocationAccessListItemDTO from 'src/models/generated/LocationAccessListItemDTO';

export interface LocationAccessTableProps {
  data?: LocationAccessListItemDTO[];
  loading?: boolean;
}

const LocationAccessTable: React.FC<LocationAccessTableProps> = (props) => {
  const [filteredInfo, setFilteredInfo] = useState<Record<string, FilterValue | null>>({});
  const [openKeys, setOpenKeys] = useState<Parameters<Required<CollapseProps>['onChange']>[0]>(['1']);
  const tableData = props.data ?? [];

  useEffect(() => {
    if (props.loading) {
      setFilteredInfo({});
    }
  }, [props.loading]);

  const tableColumns: ColumnProps<LocationAccessListItemDTO>[] = [
    TableColumnBuilder.Create<LocationAccessListItemDTO>('partner', 'Partner')
      .Width(350)
      .AddSorter('Text')
      .AddTextFilterer()
      .AddRenderer('Ellipses')
      .FilteredValue(filteredInfo)
      .Build(),
    TableColumnBuilder.Create<LocationAccessListItemDTO>('code', 'Code')
      .Width(100)
      .AddSorter('Text')
      .AddTextFilterer()
      .AddRenderer('Ellipses')
      .FilteredValue(filteredInfo)
      .Build(),
    TableColumnBuilder.Create<LocationAccessListItemDTO>('location', 'Location')
      .Width(350)
      .AddSorter('Text')
      .AddTextFilterer()
      .AddRenderer('Ellipses')
      .FilteredValue(filteredInfo)
      .Build(),
    TableColumnBuilder.Create<LocationAccessListItemDTO>('comment', 'Comment')
      // .Width(400)
      .AddSorter('Text')
      .AddTextFilterer()
      .AddRenderer('Ellipses')
      .FilteredValue(filteredInfo)
      .Build(),
    TableColumnBuilder.Create<LocationAccessListItemDTO>('disabled', 'Disabled')
      .Width(100)
      .Align('center')
      .AddRenderer('Custom', (val) => <Checkbox disabled checked={val}></Checkbox>)
      .FilteredValue(filteredInfo)
      .Build(),
  ];

  return <div className='location-access-table table-section'>
    <Collapse ghost collapsible='header' activeKey={openKeys} onChange={setOpenKeys}>
      <Collapse.Panel key={1} header={<h3 className='table-title'>Location Access</h3>}>
        <Table
          rowKey={NameOf<LocationAccessListItemDTO>('id')}
          className='condensed-table striped-table borderless-table'
          rowClassName={(record, index) => (index % 2 ? 'striped-row' : '')}
          loading={props.loading}
          pagination={false}
          columns={tableColumns}
          dataSource={tableData}
          onChange={(_, filters) => { setFilteredInfo(filters); }}
        />
      </Collapse.Panel>
    </Collapse>
  </div>;
};

export default LocationAccessTable;
